import React, { Component } from 'react';
import {Truck, Home, Unlock} from 'react-feather'
import enhanceWithClickOutside from 'react-click-outside';

import Landing from './landing/Landing'

class Welcome extends Component{
  handleClickOutside() {
    this.props.toggleWelcome()
    document.body.classList.remove('hide-overflow')
  }

  hidePopup = () => {
    this.props.toggleWelcome()
    document.body.classList.remove('hide-overflow')
  }

  render() {
    return(
      <div className="Welcome">
        <Landing />
        {/*
        <h2>Välkomen till Escapats vinabonnemang</h2>
        <div className="Welcome-row">
          <div className="Welcome-col icon">
            <Truck />
            <h3>Fri frakt</h3>
          </div>
          <div className="Welcome-col icon">
            <Home />
            <h3>Direkt till dörren</h3>
          </div>
          <div className="Welcome-col icon">
            <Unlock />
            <h3>Ingen bindningstid</h3>
          </div>
        </div>
        */}
        <div className="Welcome-bottom">
          <h3>Guide</h3>
          <p>
            1. Välj lådor för de månader du vill ha leverans.
          </p>
          <p>
            2. Spara ditt abonnemang genom att skapa ett konto.
          </p>
          <p>
            3. Sätt lösenord för ditt konto. Klart!
          </p>
        </div>
        <div className="Welcome-row">
          <div className="Welcome-col" style={{margin: "auto"}}>
            <button onClick={this.hidePopup}>Skapa abonnemang</button>
          </div>
          {/*
            <div className="Welcome-col">
              <h3>Har du redan ett konto?</h3>
              <button>Logga in</button>
            </div>
          */}
        </div>
      </div>
    )
  }
}

export default enhanceWithClickOutside(Welcome);



// WEBPACK FOOTER //
// ./src/components/Welcome.jsx